import { render } from "./4AboutUsSection.vue?vue&type=template&id=db991060&scoped=true"
import script from "./4AboutUsSection.vue?vue&type=script&lang=js"
export * from "./4AboutUsSection.vue?vue&type=script&lang=js"

import "./4AboutUsSection.vue?vue&type=style&index=0&id=db991060&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db991060"]])

export default __exports__